import React from 'react';
import { SvgIcon } from '@mui/material';

function AccountIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="0 0 54 53">
      <circle
        cx="27"
        cy="26.25"
        r="24.75"
        fill="white"
        stroke="currentColor"
        strokeWidth="3"
      />
      <circle
        cx="27.3978"
        cy="16.3068"
        r="8.44318"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        d="M7.90906 41.3637C18.47 27.4007 34.7176 25.6553 46.0909 41.3637"
        stroke="currentColor"
        strokeWidth="3"
      />
      <ellipse cx="27" cy="40.875" rx="18.75" ry="9.375" fill="currentColor" />
    </SvgIcon>
  );
}

export default AccountIcon;
